export default __webpack_public_path__ + "static/dark-chevron-1c5eed3c0c3fb943e6e5b8581ce0a196.png";